import ErrorMessage from '@common-web/error-message';
import { Checkbox as AntdCheckbox } from 'antd';
import cx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

const Checkbox = (props) => {
  const {
    children,
    label,
    size = '', // AntD Checkbox doesn’t have `size`, but we can use class
    errorMsg,
    horizontal,
    className,
    style,
    ...rest
  } = props;

  const { t } = useTranslation();

  return (
    <div
      className={cx(styles.checkboxWrapper, size, className)}
      style={{ marginInlineStart: horizontal ? 250 : undefined, ...style }}
    >
      <AntdCheckbox {...rest}>{children || t(label)}</AntdCheckbox>

      {!!errorMsg && <ErrorMessage errorMsg={errorMsg} />}
    </div>
  );
};

export default Checkbox;
